import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-and-conditions-info',
  templateUrl: './terms-and-conditions-info.component.html',
  styleUrls: ['./terms-and-conditions-info.component.scss']
})
export class TermsAndConditionsInfoComponent {

}
